export const carouselInicio = [
   {
      "imagen" : "videos/Hidalgo Unido.gif",
   },  
 
 
]